// Converts plain text or HTML description to Quill-compatible HTML.
// Plain text is escaped and wrapped in <p> tags; HTML is returned as-is.
export function normalizeDescriptionForQuill(
  description: string | null | undefined,
): string {
  const stripTags = (html: string) => {
    let current = html;
    let previous: string;

    do {
      previous = current;
      current = current.replace(/<[^>]*>/g, '');
    } while (current !== previous);

    return current;
  };
  const hasText = (html: string | null | undefined) =>
    stripTags((html ?? '').trim()).trim().length > 0;

  if (!hasText(description)) {
    return '';
  }

  const trimmed = (description ?? '').trim();

  // If it already looks like HTML/Quill output, keep it.
  const hasHtmlTag = /<([a-zA-Z][^\s/>]*)(\s[^>]*)?>/.test(trimmed);
  if (hasHtmlTag) {
    return trimmed;
  }

  // Otherwise treat as plain text and wrap into Quill-compatible paragraphs (with escaping).
  const escapeHtml = (text: string) =>
    text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const blocks = trimmed.split(/\n+/).filter(Boolean);
  return blocks.map((b) => `<p>${escapeHtml(b)}</p>`).join('');
}
